export function initTheme() {
  const STORAGE_KEY = 'dcco-theme';
  const toggles = document.querySelectorAll('[data-theme-toggle]');

  function applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem(STORAGE_KEY, theme);
    updateIcons(theme);
  }

  function updateIcons(theme) {
    toggles.forEach(btn => {
      const icon = btn.querySelector('i');
      if (!icon) return;
      if (theme === 'dark') {
        icon.className = 'fa-light fa-sun-bright';
      } else {
        icon.className = 'fa-light fa-moon-stars';
      }
    });
  }

  toggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const current = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
      applyTheme(current === 'dark' ? 'light' : 'dark');
    });
  });

  const stored = localStorage.getItem(STORAGE_KEY) || 'light';
  updateIcons(stored);
}
